// Aviso de cuota WhatsApp a partir de GET whatsapp/usage/current.
//
// El backend bloquea TODO WhatsApp a cargo del restaurante (arqueos, avisos,
// reservas, fichajes…) cuando la cuota llega a 0, también los que salen de
// TaskMicro, que no avisan en tiempo real. Por eso el aviso se decide al
// cargar: si el restaurante tiene avisos por WhatsApp configurados
// (`whatsAppConfigured`) y no le quedan mensajes, se le explica y se le
// lleva a comprar un pack.

export const LOW_THRESHOLD = 0.1;

/**
 * @param {object|null} usage respuesta de whatsapp/usage/current
 * @param {{blocked?: boolean}} opts blocked = el hub avisó de un envío bloqueado
 * @returns {null | {level: "noQuota"|"exhausted"|"low", severity: "error"|"warning", message: string}}
 */
export function whatsAppQuotaAlert(usage, { blocked = false } = {}) {
  if (!usage || usage.unlimited) return null;
  const remaining = usage.remaining ?? 0;
  const configured = !!usage.whatsAppConfigured;
  // Plan + packs (contratados y regalados). Respuestas antiguas sin
  // `cycleTotal` → solo lo incluido en el plan.
  const total = usage.cycleTotal ?? usage.includedPerCycle ?? 0;

  if (remaining <= 0) {
    if (!configured && !blocked && total <= 0) return null;
    if (total <= 0) {
      return {
        level: "noQuota",
        severity: "error",
        message:
          "Tienes avisos por WhatsApp activados, pero tu suscripción no incluye mensajes de WhatsApp: esos avisos (arqueos, reservas, fichajes…) no se están enviando. Para seguir recibiéndolos por WhatsApp, contrata uno de los packs.",
      };
    }
    return {
      level: "exhausted",
      severity: "error",
      message:
        "Te has quedado sin mensajes de WhatsApp este mes: los avisos por WhatsApp (arqueos, reservas, fichajes…) no se están enviando. Para seguir recibiéndolos, contrata uno de los packs.",
    };
  }

  if (total > 0 && remaining <= total * LOW_THRESHOLD) {
    return {
      level: "low",
      severity: "warning",
      message: `Te quedan ${remaining} mensajes de WhatsApp de ${total} este mes. Cuando se acaben, los avisos por WhatsApp dejarán de enviarse.`,
    };
  }
  return null;
}
